export default __webpack_public_path__ + "dist/media/Project.a55ef246.svg";